exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btn-remove[data-v-f8213d1c]:hover, .btn-remove[data-v-f8213d1c]:focus {\n  background: #dc3545 !important;\n}", ""]);
